require('./bootstrap');

require('./mdc');

import Vue from "vue";
window.Vue = Vue;

Vue.component("blog-component", require("./components/Blog.vue").default);

var Flickity = require('flickity');

if (screen.width >= 1024 && document.querySelector('.related-blogs')) {
    var flkty = new Flickity( '.related-blogs', {
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        pageDots: false
    });
}
